import { HoverButton, TextInput } from 'src/components';
import { Size } from 'src/constants';
import styled from 'styled-components/native';

export const MOBILE_HERO_HEIGHT = 290;

export const ContentContainer = styled.ScrollView.attrs(({ theme }) => ({
  contentContainerStyle: {
    marginHorizontal: theme.viewMode.horizontalInset,
    gap: Size.S
  }
}))`
  flex: 1;
`;

export const StyledTextInput = styled(TextInput)<{ addBottomGap?: boolean }>`
  margin-bottom: ${({ addBottomGap }) => (addBottomGap ? Size.S : 0)}px;
`;

export const HeroImageContainer = styled.Image.attrs({ resizeMode: 'cover' })`
  opacity: ${({ theme }) => (theme.dark ? 0.75 : 1)};
  width: ${({ theme }) => theme.viewMode.maxContentWidth - Size.S}px;
  height: ${({ height }) => height ?? MOBILE_HERO_HEIGHT}px;
  border-top-left-radius: ${({ theme }) => theme.roundness}px;
  border-top-right-radius: ${({ theme }) => theme.roundness}px;
`;

export const SearchByTextButton = styled(HoverButton).attrs({ mode: 'text' })`
  justify-content: flex-start;
`;

export const ButtonContainer = styled.View`
  margin-top: ${Size.M}px;
  gap: ${Size.X2_S}px;
`;

export const GappedContainer = styled.View`
  gap: ${Size.S}px;
  padding: ${Size.S}px;
`;

export const GoBackButton = styled(HoverButton).attrs({
  mode: 'text',
  uppercase: false
})`
  padding-vertical: ${Size.M}px;
`;
